import {
  Box,
  CircularProgress,
  Grid,
  Icon,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import RecruitmentPagination from 'module/recruitment/reusable/RecruitmentPagination'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { updateApplicant } from 'services/api/modules/recruitment/job-application'
import useOpenClose from 'services/hooks/useOpenClose'
import Tags from '../../recruitment-manage-applicant/components/Tags'
import CandidateInCart from './CandidateInCart'
import SummaryCart from './SummaryCart'
import { deleteCart, getCart } from 'services/api/modules/recruitment/cart'

const CartItems = () => {
  //pagination
  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerCurrentPage, setRowsPerCurrentPage] = useState(10)
  const handleChangeCurrentPage = (event, newPage) => {
    setCurrentPage(newPage)
  }
  const handleChangeRowsPerCurrentPage = (event) => {
    setRowsPerCurrentPage(parseInt(event.target.value, 10))
    setCurrentPage(0)
  }

  //modal
  const sucessRemove = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  // API CALL
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getCart')
    queryClient.resetQueries('getCart')
  }, [])
  const {
    isLoading: cartIsLoading,
    error: cartError,
    data: cartData,
  } = useQuery(
    ['getCart', rowsPerCurrentPage, currentPage],
    async () => {
      const { data } = await getCart()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const { mutate: removeFromCartMutate } = useMutation((cart_id) => deleteCart(cart_id), {
    onSuccess: async (response) => {
      await queryClient.invalidateQueries('getAllApplicant')
      queryClient.invalidateQueries('getCart')
      queryClient.resetQueries('getCart')
      sucessRemove.handleOpen()
    },
    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })

  const [candidate, setCandidate] = useState(0)
  const [selectedCart, setSelectedCart] = useState([])
  const handleSummary = (e, cartID, basePrice) => {
    const { checked } = e.target
    if (checked) {
      console.log('im acheckkkkk')
      setCandidate(candidate + 1) // set candidate counnt
      //   //   setSelectedCart([...selectedCart, { cart_id: cartID, base_price: basePrice }]) //save the cart id and the price in an array objecgt
    } else if (
      !checked
      // && candidate > 0
    ) {
      console.log('im NOTTTT acheckkkkk')

      setCandidate(candidate - 1)
      //   setSelectedCart(selectedCart.filter((item) => item.cart_id !== cartID)) //remove the cart id and the price in an array objecgt
    }
  }
  // create array of cart id
  const cartIds = selectedCart.map((item) => item.cart_id)

  // create array of cart price
  const price = selectedCart.map((item) => item.base_price)

  //array sum of cart price
  const totalPrice = price.reduce((acc, current) => acc + current, 0)

  //Checkbox function
  const changeCheckboxStatus = (e, id) => {
    const { checked } = e.target
    console.log('🚀 ~ changeCheckboxStatus ~ checked:', checked)
    // cartData?.data?.map((user) => {
    //   if (user.id === id) {
    //     user.isChecked = checked
    //   }

    //   return user
    // })
  }

  const theme = useTheme()
  const isLG = useMediaQuery(theme.breakpoints.up('lg'))

  const employeeColumn = [
    {
      Header: 'name',
      accessor: 'relations.cartable.name',
      Cell: (props) => {
        const { value } = props

        return (
          <Box display="flex" alignItems="center">
            <Box>
              <AdxFormControlLabel
                type="no-fill"
                control={
                  <AdxCheckbox
                    // checked={props?.row?.original?.isChecked}
                    onChange={(e) => {
                      // changeCheckboxStatus(e, props?.row?.original?.id)
                      handleSummary(e, props?.row?.original?.id, props?.row?.original?.unit_price)
                    }}
                  />
                }
              />
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={45}
              height={45}
              bgcolor="default-background.main"
              color="light-gray-text.main"
              borderRadius="50%"
            >
              <Icon>lock</Icon>
            </Box>
            <Box ml={2}>
              <Typography
                sx={{ wordWrap: 'break-word', minWidth: isLG ? 250 : 100, maxWidth: 450 }}
              >
                {value}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      Header: 'video',
      accessor: 'relations.cartable.has_video_interview',
      Cell: (props) => {
        const { value } = props
        return (
          <Box display="flex" columnGap={2}>
            <Tags typo="body1" icon="article" word="Resume" />
            {value ? <Tags typo="body1" icon="video_file" word="Video" /> : null}
          </Box>
        )
      },
    },
    {
      Header: 'price',
      accessor: 'unit_price',
      Cell: (props) => {
        const { value } = props
        return (
          <Box display="flex" columnGap={2} alignItems="center">
            <Box>
              <Typography
                variant="h4"
                color="dark-text.main"
                sx={{
                  fontWeight: 'bold',
                  textAlign: 'left',
                }}
              >
                RM{value}
              </Typography>
            </Box>
            <Box
              onClick={() => {
                removeFromCartMutate(props?.row?.original?.id)
              }}
            >
              <Icon sx={{ color: 'error.main', fontSize: 25, cursor: 'pointer' }}>delete_icon</Icon>
            </Box>
          </Box>
        )
      },
    },
  ]

  //custom  empty state
  const CartEmpty = ({ icon = 'shopping_cart', message = 'Your cart is empty' }) => (
    <Box
      height={200}
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="gray-background.main"
      width={1}
      borderRadius={3}
      boxSizing="border-box"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        rowGap={1}
      >
        <Icon sx={{ fontSize: 65, color: 'light-gray-text.main' }}>{icon}</Icon>
        <Typography align="center" variant="h3" color="dark-text.main">
          {message}
        </Typography>
        <Typography align="center" variant="body1" color="light-gray-text.main">
          There are currently no candidate added to your cart yet
        </Typography>
      </Box>
      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}

      {sucessRemove.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Applicant removed from cart"
          open={sucessRemove.isOpen}
          handleClose={sucessRemove.handleClose}
        />
      ) : null}
    </Box>
  )

  if (cartIsLoading) {
    return (
      <Box marginTop={2} display="flex" alignItems="center" justifyContent="center" gap={2}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={30}
          sx={{
            height: '100%',
            width: '100%',
          }}
        >
          <CircularProgress color="alternate" />
        </Box>
      </Box>
    )
  } else if (cartError !== null || cartData === undefined || cartData?.length < 1) {
    return (
      <Box marginTop={2} px={10}>
        <Grid container spacing={2} columns={16}>
          <Grid item xs={11}>
            <Box
              marginTop={5}
              display="flex"
              flexDirection="column"
              gap={2}
              padding={2}
              alignItems="center"
              justifyContent="center"
              sx={{ height: 700 }}
            >
              <CartEmpty />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <SummaryCart selectedCart={cartIds} totalPrice={totalPrice} candidate={candidate} />
          </Grid>
        </Grid>
      </Box>
    )
  } else {
    return (
      <Box marginTop={2}>
        <Grid container spacing={2} columns={16}>
          <Grid item xs={11}>
            <Box marginTop={8} ml={2}>
              <CandidateInCart column={employeeColumn} data={cartData ?? null} />
              <Box
                display="flex"
                justifyContent="flex-end"
                bgcolor="white.main"
                sx={{
                  width: '100%',
                  borderBottomRightRadius: 2,
                  borderBottomLeftRadius: 2,
                }}
              >
                <RecruitmentPagination
                  count={cartData?.total}
                  page={currentPage}
                  onPageChange={handleChangeCurrentPage}
                  rowsPerPage={rowsPerCurrentPage}
                  onRowsPerPageChange={handleChangeRowsPerCurrentPage}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <SummaryCart selectedCart={cartIds} totalPrice={totalPrice} candidate={candidate} />
          </Grid>
        </Grid>

        {errorSnackbar.isOpen ? (
          <SnackbarRecruitment
            autoHideDuration={4000}
            status="error"
            TransitionComponent="slide"
            message="An error has occured. Please try again"
            open={errorSnackbar.isOpen}
            handleClose={errorSnackbar.handleClose}
          />
        ) : null}

        {sucessRemove.isOpen ? (
          <SnackbarRecruitment
            autoHideDuration={4000}
            status="success"
            TransitionComponent="slide"
            message="Applicant removed from cart"
            open={sucessRemove.isOpen}
            handleClose={sucessRemove.handleClose}
          />
        ) : null}
      </Box>
    )
  }
}
export default CartItems
